module.exports = __webpack_public_path__ + "img/five-4.4ca8c6f7.png";